module.exports = __webpack_public_path__ + "static/media/harts_bg.d5450933.jpeg";